import React, { useState, useEffect } from "react";
import { Switch } from "@headlessui/react";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faCloudUpload,
  faTrash,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAxiosInstance } from "../../../services/Interceptor";
import {
  CreateAccolade,
  CreateOffer,
  getAthleteProfile,
  updateProfileIsPublic,
} from "../../../services/AthleteService";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOffers,
  fetchAccolades,
  fetchProfilePhoto,
} from "../../../store/AthleteActions";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { uploadProfilePhoto } from "../../../services/FileUploadService";
import { PersonalInfoAthlete } from "../account/PersonalInfoAthlete";
import DeleteAccolade from "./delete-accolade";
import DeleteOffer from "./delete-offer";
import UpdatePassword from "./UpdatePassword";
import { AthleteReview } from "./athletereview";
import moment from "moment/moment";
import PaymentUpdate from "../../../components/PaymentUpdate";
import { Navigate } from "react-router-dom";
import ProfileVideo from "./profile-videos/profile-video";
import WeightRoom from "./weight-room/weight-room";
import ProfileVideosLinks from "./profile-videos-links/profile-videos-links";
import UpdateBio from "./UpdateBio";

function AthleteData() {
  const [enabled, setEnabled] = useState();
  let [isOpen, setIsOpen] = useState(false);
  let [isOfferOpen, setIsOfferOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();
  const {
    register: accoladeRegister,
    handleSubmit: handleAccoladeSubmit,
    reset: resetAccolade,
  } = useForm();
  const {
    register: offerRegister,
    handleSubmit: handleOfferSubmit,
    reset: resetOffer,
  } = useForm();
  const { offers, accolades, profilePhoto } = useSelector(
    (state) => state.athletes,
  );
  const authUser = useAuthUser();
  const [isUploading, setIsUploading] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);
  const [deleteAccoladeOpen, setDeleteAccoladeOpen] = useState(false);
  const [accoladeIdSelected, setAccoladeIdSelected] = useState(undefined);
  const [deleteOfferOpen, setDeleteOfferOpen] = useState(false);
  const [offerIdSelected, setOfferIdSelected] = useState(undefined);
  const date = moment();
  const [tab, setTab] = useState(1);
  const [showInfoUpload, setShowInfoUpload] = useState(false);
  const [showInfoLinks, setShowInfoLinks] = useState(false);

  useEffect(() => {
    if (!authUser || !authUser?.user) {
      return <Navigate to="/sign-in" replace />;
    }
  });

  useEffect(() => {
    dispatch(fetchOffers(apiInstance, authUser?.user?.id));
    dispatch(fetchAccolades(apiInstance, authUser?.user?.id));
    dispatch(fetchProfilePhoto(apiInstance, authUser?.user?.id));
  }, [dispatch, apiInstance, authUser?.user?.id]);

  useEffect(() => {
    if (profilePhoto) {
      setProfilePicture(profilePhoto);
    }
    const getProfile = async () => {
      try {
        const response = await getAthleteProfile(
          apiInstance,
          authUser?.user?.id,
        );
        if (response) {
          setEnabled(response.isPublic);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (authUser?.user?.id) {
      getProfile();
    }
  }, [profilePhoto, authUser, apiInstance]);

  const handleAccoladeSubmission = async (data) => {
    setLoading(true);
    try {
      await CreateAccolade(apiInstance, data);
      toast.success("Accolade created successfully!", {
        position: "top-right",
      });
      setIsOpen(false);
      resetAccolade();
      dispatch(fetchAccolades(apiInstance, authUser?.user?.id));
    } catch (error) {
      toast.error("Failed to create Accolade!", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  // Offer form submission
  const handleOfferSubmission = async (data) => {
    setLoading(true);
    try {
      await CreateOffer(apiInstance, data);
      toast.success("Offer created successfully!", { position: "top-right" });
      setIsOfferOpen(false);
      resetOffer();
      dispatch(fetchOffers(apiInstance, authUser?.user?.id));
    } catch (error) {
      toast.error("Failed to create Offer!", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  const validateFile = (file) => {
    const permittedExtensions = [".jpg", ".jpeg", ".png", ".gif"];
    const permittedMimeTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxFileSize = 10 * 1024 * 1024;

    const fileExtension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    const isExtensionValid = permittedExtensions.includes(fileExtension);
    const isMimeTypeValid = permittedMimeTypes.includes(file.type);
    const isSizeValid = file.size <= maxFileSize;

    if (!isExtensionValid) {
      toast.error(
        "Invalid file extension. Only JPG, PNG, and GIF are allowed.",
        {
          position: "top-right",
        },
      );
      return false;
    }

    if (!isMimeTypeValid) {
      toast.error("Invalid file type. Please upload an image file.", {
        position: "top-right",
      });
      return false;
    }

    if (!isSizeValid) {
      toast.error("File size exceeds the 10 MB limit.", {
        position: "top-right",
      });
      return false;
    }

    return true;
  };

  const style = {
    ul: "flex space-x-0 mt-0 border-b border-gray-300",
    li: "text-gray-900 pb-2 px-3 hover:opacity-70 text-sm xl:text-base cursor-pointer",
    selected:
      "cursor-default border-b-4 border-blue-700 text-sm xl:text-base text-blue-700 pb-2 px-3 font-medium ",
  };

  const uploadSelectedProfilePhoto = async (file) => {
    if (isUploading || !file || !validateFile(file)) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsUploading(true);
      await uploadProfilePhoto(apiInstance, formData);
      setTimeout(() => {
        dispatch(fetchProfilePhoto(apiInstance, authUser?.user?.id));
        setProfilePicture(profilePhoto);
        setIsUploading(false);
      }, 2000);
      toast.success("Photo uploaded successfully!", {
        containerId: "modal",
      });
    } catch (error) {
      toast.error("Failed to upload photo!", { position: "top-right" });
      setIsUploading(false);
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    event.target.value = "";
    await uploadSelectedProfilePhoto(file);
  };

  const handleDragDropUpload = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    await uploadSelectedProfilePhoto(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const openDeleteAccolade = (accoladeIde) => {
    setAccoladeIdSelected(accoladeIde);
    setDeleteAccoladeOpen(true);
  };

  const openDeleteOffer = (offerId) => {
    setOfferIdSelected(offerId);
    setDeleteOfferOpen(true);
  };

  const enableProfileIsPublic = async (e) => {
    try {
      var updatedResponse = await updateProfileIsPublic(
        apiInstance,
        !e,
        authUser?.user?.id,
      );
      if (updatedResponse) {
        setEnabled(!e);
      }
    } catch (err) {
      toast.error(`Error to enable athlete status ${err.error}`, {
        position: "top-center",
      });
    }
  };

  return (
    <>
      <div className="flex-none md:flex xl:flex bg-gray-100 gap-3 h-full">
        <div className="w-full md:w-2/3 xl:w-2/3">
          <div className="grid grid-cols-1 gap-y-3 h-full">
            {/* info profile */}
            <PersonalInfoAthlete />
            {/* update password */}
            <UpdatePassword title="Update Password" />
            {/* end  update password */}
            {/* update bio*/}
            <UpdateBio />
            {/* end update bio*/}

            {/* Profile Settings Start */}
            <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
              <div className="w-full">
                <h2 className="text-xl mb-6 uppercase ">Profile picture</h2>
                <div className="grid grid-cols-3 gap-4">
                  <div
                    className="flex items-center justify-items-end"
                    onDrop={handleDragDropUpload}
                    onDragOver={handleDragOver}
                  >
                    {isUploading ? (
                      <div className="border border-blue-700 border-dashed rounded-lg p-4 bg-[#E6E3E3] flex items-center justify-center">
                        <LoadingSpinner />
                      </div>
                    ) : profilePicture ? (
                      <div className="relative border border-blue-700 border-dashed rounded-lg cursor-pointer px-4 py-4 bg-[#E6E3E3]">
                        <img
                          src={profilePicture.fileUrl}
                          alt="Profile"
                          className="h-[148px] w-[148px] object-cover rounded-lg"
                        />
                        <label
                          htmlFor="Upload"
                          className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity"
                        >
                          <FontAwesomeIcon
                            icon={faCloudUpload}
                            className="text-white h-6"
                          />
                          <p className="mb-2 text-sm text-white text-center">
                            <span className="font-normal">
                              Drag and drop or click to upload image
                            </span>
                          </p>
                        </label>
                        <input
                          id="Upload"
                          type="file"
                          className="hidden"
                          onChange={handleFileUpload}
                        />
                      </div>
                    ) : (
                      <label
                        htmlFor="Upload"
                        className="border border-blue-700 border-dashed rounded-lg cursor-pointer px-4 py-4 bg-[#E6E3E3]"
                      >
                        <div className="flex flex-col items-center">
                          <FontAwesomeIcon
                            icon={faCloudUpload}
                            className="text-gray-600 h-6"
                          />
                          <p className="mb-2 text-sm text-gray-500 text-center">
                            <span className="font-normal">
                              Drag & Drop Image Or Click to Upload
                            </span>
                          </p>
                        </div>
                        <input
                          id="Upload"
                          type="file"
                          className="hidden"
                          onChange={handleFileUpload}
                        />
                      </label>
                    )}
                  </div>
                  <div className="text-base text-gray-700 text-right">
                    Public Profile
                  </div>
                  <div>
                    <Switch
                      checked={!enabled}
                      onChange={enableProfileIsPublic}
                      className="group relative flex h-7 w-14 cursor-pointer rounded-full bg-blue-700 p-1 transition-colors duration-200 ease-in-out focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white data-[checked]:bg-gray-300"
                    >
                      <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block size-5 translate-x-0 rounded-full bg-white ring-0 shadow-lg transition duration-200 ease-in-out group-data-[checked]:translate-x-7"
                      />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
            {/* Profile Settings End */}
            {/* Profile Settings End */}
          </div>
        </div>
        <div className="w-full md:w-2/3 xl:w-2/3 mt-4 md:mt-0 xl:mt-0">
          <div className="grid grid-cols-1 gap-y-3 h-full">
            {/* Accolades and Offers Section */}
            <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
              <div className="w-full">
                <h2 className="text-xl mb-2 uppercase">Offers</h2>

                <div className="top-0 bg-white z-20">
                  <ul className={style.ul}>
                    <li
                      className={`hidden ${tab === 0 ? style.selected : style.li}`}
                      onClick={() => setTab(0)}
                    >
                      Accolades
                    </li>
                    <li
                      className={`hidden ${tab === 0 ? style.selected : style.li}`}
                      onClick={() => setTab(0)}
                    >
                      Offers
                    </li>
                    <li
                      className={tab === 1 ? style.selected : style.li}
                      onClick={() => setTab(1)}
                    >
                      Profile Video Uploads
                    </li>
                    <li
                      className={tab === 2 ? style.selected : style.li}
                      onClick={() => setTab(2)}
                    >
                      Profile Video Links
                    </li>

                    <li
                      className={tab === 3 ? style.selected : style.li}
                      onClick={() => setTab(3)}
                    >
                      Weight Room
                    </li>
                  </ul>

                  {tab === 0 && (
                    <div>
                      {/* Accolades Panel */}
                      <div className="mt-4">
                        <div
                          className="float-right text-sm text-white border border-gray-300 p-2 rounded  bg-blue-600 hover:bg-blue-800   cursor-pointer"
                          onClick={() => setIsOpen(true)}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add new Accolades
                        </div>
                        <h2 className="font-medium mb-4 uppercase">
                          Accolades
                        </h2>
                        <div className="clear-both"></div>
                        <div className="clear-both"></div>
                        {Array.isArray(accolades) && accolades.length > 0 ? (
                          <div className="grid grid-cols-4 gap-4 border border-blue-700 rounded-md p-4 text-gray-800 items-center mb-4 mt-2">
                            {accolades.map((accolade, index) => (
                              <React.Fragment key={index}>
                                <div className="">
                                  {accolade.accoladeDescription}
                                </div>
                                <div className="truncate">
                                  <a
                                    href={accolade.accoladeLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:underline truncate"
                                  >
                                    {accolade.accoladeLink}
                                  </a>
                                </div>
                                <div className="justify-self-end font-bold">
                                  {accolade.accoladeYear}
                                </div>
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  className="justify-self-end text-red-700 cursor-pointer"
                                  onClick={() =>
                                    openDeleteAccolade(accolade.id)
                                  }
                                />
                              </React.Fragment>
                            ))}
                          </div>
                        ) : (
                          <div
                            onClick={() => setIsOpen(true)}
                            className="hover:underline text-blue-700 cursor-pointer"
                          >
                            Add your first accolade here
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {tab === 0 && (
                    <div>
                      {/* Offers Panel */}
                      <div className="mt-4">
                        <div
                          className="float-right text-sm text-white border border-gray-300 p-2 rounded  bg-blue-600 hover:bg-blue-800   cursor-pointer"
                          onClick={() => setIsOfferOpen(true)}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add new Offers
                        </div>

                        <h2 className="font-medium mb-4 uppercase">Offers</h2>
                        <div className="clear-both"></div>
                        {Array.isArray(offers) && offers.length > 0 ? (
                          <div className="grid grid-cols-4 gap-4 border border-blue-700 rounded-md p-4 text-gray-800 items-center mb-4 mt-2">
                            {offers.map((offer, index) => (
                              <React.Fragment key={index}>
                                <div>{offer.schoolName}</div>
                                <div>{offer.division}</div>
                                <div className="justify-self-end font-bold">
                                  {offer.offerYear}
                                </div>
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  className="justify-self-end text-red-700 cursor-pointer"
                                  onClick={() => openDeleteOffer(offer.id)}
                                />
                              </React.Fragment>
                            ))}
                          </div>
                        ) : (
                          <div
                            onClick={() => setIsOfferOpen(true)}
                            className="hover:underline text-blue-700 cursor-pointer"
                          >
                            Add your first offer here
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {tab === 1 && (
                    <div className="mt-4">
                      {/* Profile Video Uploads Panel */}
                      <h2 className="font-medium mb-4 uppercase">
                        Profile Videos{" "}
                        <FontAwesomeIcon
                          className="ml-2 cursor-pointer text-base"
                          icon={faInfoCircle}
                          onClick={() => setShowInfoUpload(true)}
                        />
                      </h2>
                      <ProfileVideo />
                    </div>
                  )}
                  {tab === 2 && (
                    <div>
                      {/* Profile Video Links Panel */}
                      <ProfileVideosLinks />
                    </div>
                  )}
                  {tab === 3 && (
                    <div>
                      {/* Weight Room Panel */}
                      <WeightRoom />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
              <div className="w-full">
                <h2 className="text-xl uppercase text-left">
                  Review your Trackit experience
                </h2>
                <div className="w-full">
                  <AthleteReview />
                </div>
              </div>
            </div>
            <div className="w-full hidden">
              <PaymentUpdate
                account={authUser?.user?.id}
                email={authUser?.user?.email}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Accolades modal */}
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-50"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity"
        />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg">
            <div className="p-8">
              <DialogTitle className="text-xl uppercase pb-4">
                New Accolade
              </DialogTitle>
              <form onSubmit={handleAccoladeSubmit(handleAccoladeSubmission)}>
                <div className="flex flex-wrap -mx-3">
                  <div className="w-full px-3 mb-4">
                    <label
                      className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                      htmlFor="accoladeDescription"
                    >
                      Description
                    </label>
                    <input
                      id="accoladeDescription"
                      type="text"
                      {...accoladeRegister("accoladeDescription", {
                        required: "Description is required",
                      })}
                      placeholder="Description..."
                      className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>
                  <div className="w-full px-3 mb-4">
                    <label
                      className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                      htmlFor="accoladeLink"
                    >
                      Link
                    </label>
                    <input
                      id="accoladeLink"
                      type="text"
                      {...accoladeRegister("accoladeLink")}
                      placeholder="Link..."
                      className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                      htmlFor="accoladeYear"
                    >
                      Year
                    </label>
                    <input
                      id="accoladeYear"
                      type="number"
                      min={2000}
                      max={date.year()}
                      {...accoladeRegister("accoladeYear", {
                        required: "Year is required",
                      })}
                      defaultValue={date.year()}
                      placeholder="Year..."
                      className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>
                </div>
                <div className="form-field mt-4">
                  {loading && <LoadingSpinner />}
                </div>
                <div className="flex gap-4 sm:flex sm:flex-row-reverse p-4">
                  <button
                    type="submit"
                    className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700 ml-3"
                  >
                    Add
                  </button>
                  <button
                    type="reset"
                    onClick={() => {
                      setIsOpen(false);
                      resetAccolade();
                    }}
                    className="text-gray-600  hover:text-gray-800"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
      {/* Offers modal */}
      <Dialog
        open={isOfferOpen}
        onClose={() => setIsOfferOpen(false)}
        className="relative z-50"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity"
        />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg">
            <div className="p-8">
              <DialogTitle className="text-xl uppercase pb-4">
                New Offer
              </DialogTitle>
              <form onSubmit={handleOfferSubmit(handleOfferSubmission)}>
                <div className="flex flex-wrap -mx-3">
                  <div className="w-full px-3 mb-4">
                    <label
                      className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                      htmlFor="schoolName"
                    >
                      School
                    </label>
                    <input
                      id="schoolName"
                      type="text"
                      {...offerRegister("schoolName", {
                        required: "School is required",
                      })}
                      placeholder="School..."
                      className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>
                  <div className="w-full px-3 mb-4">
                    <label
                      className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                      htmlFor="division"
                    >
                      Division
                    </label>
                    <select
                      id="division"
                      {...offerRegister("division", {
                        required: "Division is required",
                      })}
                      className="form-select bg-no-repeat block appearance-none w-full border border-gray-300 text-gray-900 p-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white"
                    >
                      <option value="Division 1 (FBS)">Division 1 (FBS)</option>
                      <option value="Division 1 (FCS)">Division 1 (FCS)</option>
                      <option value="Division 2">Division 2</option>
                      <option value="Division 3">Division 3</option>
                      <option value="Juco">Juco</option>
                      <option value="NAIA">NAIA</option>
                    </select>
                  </div>
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                      htmlFor="offerYear"
                    >
                      Year
                    </label>
                    <input
                      id="offerYear"
                      type="number"
                      min={2000}
                      max={date.year()}
                      {...offerRegister("offerYear", {
                        required: "Year is required",
                      })}
                      defaultValue={date.year()}
                      placeholder="Year..."
                      className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>
                </div>
                <div className="form-field mt-4">
                  {loading && <LoadingSpinner />}
                </div>
                <div className="flex gap-4 bg-gray-50 sm:flex sm:flex-row-reverse p-4">
                  <button
                    type="submit"
                    className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700 ml-3"
                  >
                    Add
                  </button>
                  <button
                    type="reset"
                    onClick={() => {
                      setIsOfferOpen(false);
                      resetOffer();
                    }}
                    className="text-gray-600 font-semibold hover:text-gray-800"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
      <DeleteAccolade
        deleteAccoladeOpen={deleteAccoladeOpen}
        closeDeleteAccolade={() => setDeleteAccoladeOpen(false)}
        accoladeId={accoladeIdSelected}
      />
      <DeleteOffer
        deleteOfferOpen={deleteOfferOpen}
        closeDeleteOffer={() => setDeleteOfferOpen(false)}
        offerId={offerIdSelected}
      />

      {/* Modals for information */}
      {showInfoUpload && (
        <Modal
          title="Profile Video uploads"
          description="These videos will be viewable by coaches directly in the platform.  If the following videos are hosted elsewhere use the profile video links tab to add links that the coaches can see."
          onClose={() => setShowInfoUpload(false)}
        />
      )}

      {showInfoLinks && (
        <Modal
          title="Profile video links"
          description="Coaches will be able to follow these links to an external site where you have hosted your videos.  Please ensure that the links you post are to publicly hosted videos.  If you prefer to upload and host videos directly in this platform use the Profile Video Uploads tab."
          onClose={() => setShowInfoLinks(false)}
        />
      )}
    </>
  );
}

function Modal({ title, description, onClose }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-3/4 max-w-md">
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        <p className="text-sm mb-6">{description}</p>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default AthleteData;
